// laravel passport

import { PbxHttpClient } from "@/services/httpclient";

const state = {
  report: [
    { name: "LLamadas ingresadas", value: 0 },
    { name: "LLamadas contestadas", value: 0 },
    { name: "LLamadas abandonadas", value: 0 },
    { name: "Eficiencia en la atención", value: `${0} %` },
    { name: "Promedio de espera", value: `${0} seg` },
    { name: "Promedio de conservación", value: `${0} seg` },
    { name: "Promedio de abandono", value: `${0} seg` },
  ],

  graph2: [],
  graph3: {},

  token: null,
};

const getters = {
  /**
   * [GRAPH_1 description]
   * values de los reportes guardados en string
   * @param {[type]} state [description]
   */
  GRAPH_1(state) {
    const total =
      parseFloat(state.report[1].value) + parseFloat(state.report[2].value);
    // console.log(total);
    let per1 = 0;
    let per2 = 0;

    if (total > 0) {
      per1 = parseFloat(
        (parseFloat(state.report[1].value) * 100) / total
      ).toFixed(2);

      per2 = parseFloat(
        (parseFloat(state.report[2].value) * 100) / total
      ).toFixed(2);
    }
    return [
      [`CONTESTADAS % ${per1}`, state.report[1].value],
      [`ABANDONADAS % ${per2}`, state.report[2].value],
    ];
  },
};

const mutations = {
  ARRAY_REPLACE: (state, payload) => {
    // asignar valores consulta
    state.report[0].value = payload.entered.toLocaleString("es-ve");
    state.report[1].value = payload.replied.toLocaleString("es-ve");
    state.report[2].value = payload.abandoned.toLocaleString("es-ve");
    // porcentaje
    if (payload.entered > 0) {
      state.report[3].value = `${parseFloat(
        (payload.replied / payload.entered) * 100
      )
        .toFixed(2)
        .toLocaleString("es-ve")} %`;
    } else {
      state.report[3].value = `${0} %`;
    }
    if (payload.average_wait > 0 && payload.entered > 0) {
      // console.log(payload.average_wait);
      state.report[4].value = `${(payload.average_wait / 1000)
        .toFixed(2)
        .toLocaleString("es-ve")} seg`;
    } else {
      state.report[4].value = `${0} seg`;
    }
    if (payload.average_conversation > 0 && payload.entered > 0) {
      state.report[5].value = `${(payload.average_conversation / 1000)
        .toFixed(2)
        .toLocaleString("es-ve")} seg`;
    } else {
      state.report[5].value = `${0} seg`;
    }
    if (payload.average_abandonment > 0 && payload.entered > 0) {
      state.report[6].value = `${(payload.average_abandonment / 1000)
        .toFixed(2)
        .toLocaleString("es-ve")} seg`;
    } else {
      state.report[6].value = `${0} seg`;
    }
  },

  /**
   * [SET_GRAPH3 description]
   * @param {[type]} state   [description]
   * @param {[array]} payload [description]
   */
  SET_GRAPH2(state, payload) {
    const graph = [];
    for (const obj of payload) {
      // console.log(obj);
      graph.push([obj.agent, obj.total]);
    }

    state.graph2 = graph;
  },

  SET_GRAPH3(state, payload) {
    const graph = {};
    for (const obj of payload) {
      // console.log(obj);
      for (const prop in obj) {
        // console.log(prop);
        // console.log(obj[prop]);
        Object.defineProperty(graph, prop, {
          value: obj[prop],
          writable: true,
          enumerable: true,
          configurable: true,
        });
      }
    }
    state.graph3 = graph;
  },
};

const actions = {
  /**
   * [GET_REPORT description]
   * request: {
   *   format: D | M | Y | P,
   *   value: yyyy-mm-dd | { start: yyyy-mm-dd, end: yyyy-mm-dd}
   * }
   * @param {[type]} options.state  [description]
   * @param {[type]} options.commit [description]
   * @param {[type]} request        [description]
   */
  async GET_REPORT({ state, commit }, request) {
    try {
      const response = await PbxHttpClient.post(`/reports/tail/`, request);
      // commit('ARRAY_REPLACE', res.data);
      // commit('SET_GRAPH2', res.data.graph2);
      // commit('SET_GRAPH3', res.data.graph3);
      return response.data;
    } catch (error) {
      console.log(error);
      return Promise.reject();
    }
  },
};

// exportar propiedades
export const tail = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
